import { put, takeLatest, call } from '@redux-saga/core/effects';
import { create_group, create_group_success, create_group_error } from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* createUserGroupSagas({ payload }) {
  try {
    const requestRes = yield call(api.post, `/groups`, payload);
    const responseData = requestRes.data;
    const response = responseData.data;
    toast.success(responseData.message);
    setTimeout(() => {
      window.location.href = `/baskets/basket/${response._id}`;
    }, 1000);
    yield put({
      type: create_group_success.type,
      payload: response,
    });
  } catch (error) {
    if (error.response.data) {
      toast.error(error.response.data.message);
      yield put({
        type: create_group_error.type,
      });
    } else {
      yield put({
        type: create_group_error.type,
      });
    }
  }
}

function* createGroupSagas() {
  yield takeLatest(create_group.type, createUserGroupSagas);
}

export default createGroupSagas;
